// src/features/reports/components/Reports/index.jsx
// ✅ المكوّن الرئيسي — orchestrator نظيف، كل المنطق في useReportsData

import React        from 'react';
import styles       from './Reports.module.css';
import PrintableReport from '../../../../shared/components/print/PrintableReport';

import useReportsData from './hooks/useReportsData';
import ReportsHeader      from './components/ReportsHeader';
import ReportsFilters     from './components/ReportsFilters';
import ReportsStatsStrip  from './components/ReportsStatsStrip';
import ReportsCharts      from './components/ReportsCharts';
import ReportsTableSection from './components/ReportsTableSection';

export default function Reports() {
  const {
    // data
    reportData, settings, loading, error,
    // filters
    filters, allowedBookingTypes,
    handleFilterChange, generateReport,
    // view state
    tableView, setTableView,
    expenseFilter, setExpenseFilter,
    displayMode, setDisplayMode,
    // pagination
    revPage, setRevPage, revRows,
    expPage, setExpPage, expRows,
    // derived
    netProfit, totalExpenses, genExpValue,
    filteredExpenses, isSpecFilter,
    // print / export
    printableRef, handlePrint, handleExport,
  } = useReportsData();

  return (
    <div className={styles.page}>

      {/* مخفي للطباعة */}
      <div style={{ display: 'none' }}>
        <PrintableReport
          ref={printableRef}
          reportData={reportData}
          filters={filters}
          settings={settings}
        />
      </div>

      {/* ── رأس الصفحة ── */}
      <ReportsHeader
        filters={filters}
        loading={loading}
        reportData={reportData}
        onGenerate={generateReport}
        onExport={handleExport}
        onPrint={handlePrint}
      />

      {/* ── الفلاتر ── */}
      <ReportsFilters
        filters={filters}
        allowedBookingTypes={allowedBookingTypes}
        onChange={handleFilterChange}
      />

      {/* ── خطأ ── */}
      {error && <p className={styles.errorMsg}>{error}</p>}

      {/* ── تحميل ── */}
      {loading && (
        <div className={styles.loadingWrap}>
          <div className={styles.loadingSpinner} />
          <p>جاري تحميل التقرير…</p>
        </div>
      )}

      {/* ── النتائج ── */}
      {!loading && reportData && (
        <>
          {/* شريط الإحصائيات */}
          <ReportsStatsStrip
            summary={reportData.summary}
            netProfit={netProfit}
            totalExpenses={totalExpenses}
            genExpValue={genExpValue}
            tableView={tableView}
            expenseFilter={expenseFilter}
            onSetView={setTableView}
            onSetExpFilter={v => { setExpenseFilter(v); setExpPage(1); }}
          />

          {/* الشارتات */}
          <ReportsCharts
            reportData={reportData}
            netProfit={netProfit}
            totalExpenses={totalExpenses}
          />

          {/* قسم الجدول / البطاقات */}
          <ReportsTableSection
            reportData={reportData}
            tableView={tableView}       setTableView={setTableView}
            displayMode={displayMode}   setDisplayMode={setDisplayMode}
            expenseFilter={expenseFilter} setExpenseFilter={setExpenseFilter}
            isSpecFilter={isSpecFilter}
            revRows={revRows}   revPage={revPage}   setRevPage={setRevPage}
            expRows={expRows}   expPage={expPage}   setExpPage={setExpPage}
            filteredExpenses={filteredExpenses}
          />
        </>
      )}

    </div>
  );
}